<app-header></app-header>
<div class="section container-fluid py-3">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section">
            <div class="row p-2">
                <div class="col-sm-4 pt-2">
                    <span class="title">My notes</span>
                </div>
                <div class="col-sm-8 col-md-6 col-lg-5 col-xl-4 mt-2 mt-sm-0">
                    <div class="input-icons">
                        <i class="fas fa-search"></i>
                        <input class="form-control form-control-lg search" [(ngModel)]="searchText"
                            placeholder="Search note" (keyup.enter)="searchNote()">
                    </div>
                </div>
            </div>
            <div class="horizontal-line"></div>
            <div class="wrapper pb-3" *ngIf="notes.length">
                <div class="notes-section mt-3 p-2" *ngFor="let note of notes">
                    <div class="d-flex flex-row justify-content-between">
                        <span class="section-title">{{note?.noteTitle}}</span>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </div>
                    <div class="note-sub-title-section">
                        <span class="sub-title mt-1">{{note?.noteText}}</span>
                    </div>
                    <div class="horizontal-line my-2"></div>
                    <span class="note-time">{{note?.createdAt | date:'MMM dd EEE, h:mma'}}</span>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="editNote(note)" data-toggle="modal" data-target="#create-note">
                            <mat-icon>edit_outline</mat-icon>
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item (click)="deleteNote(note.noteId)">
                            <mat-icon>delete_outline</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
            <div class="no-data" *ngIf="!notes.length && !loading">
                <img class="align-self-center" src="../../../assets/Images/NoDocuments.png" height="50" width="80"
                    alt="No Notes">
                <span>No Notes</span>
            </div>
            <div class="row my-5" *ngIf="loading">
                <div class="spinner-border loader" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>

<app-create-note (note)="updateNotes($event)"></app-create-note>